/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(categoryId, existingContactTypes, contactTypeId) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetBankParityLookups: {
        $xmlns: 'http://dobs.pa.gov/dp/lookup/bpm/1.0'
      }
    },
    blueprintArrays: [
      'GetBankParityLookupsResponse.Authorities.DP_LU_BankParityAuthority',
      'GetBankParityLookupsResponse.ActivityTypes.DP_LU_BankParitySubsidiaryActivityType'
    ],
    blueprint: {
      authorities: [
        '$..DP_LU_BankParityAuthority',
        {
          id: '$..ID',
          authority: '$..Authority'
        }
      ],
      activityTypes: [
        '$..DP_LU_BankParitySubsidiaryActivityType',
        {
          id: '$..ID',
          activityType: '$..ActivityType'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
